// extracted by mini-css-extract-plugin
export default {"preloader_connent":"preloader_preloader_connent__eNhGj","preloader_image":"preloader_preloader_image__ieSQE","preloader-rotate":"preloader_preloader-rotate__xdShr"};